import { InventoryHierarchicalItemType } from './inventory-itemtype';
import { HiveApplication } from 'src/app/applications/hive-application';
import { InventoryRecord } from './inventory-record';
import { InventoryAggregate } from './inventory-aggregate';
import { sum, groupBy } from 'lodash-es';

export class InventoryAggregateHelper {
  buildOverview(
    itemTypes: InventoryHierarchicalItemType[],
    items: HiveApplication[],
    records: InventoryRecord[]
  ): InventoryAggregate[] {
    const purchased = groupBy(records, 'itemType.id');
    const out = groupBy(items, 'itemType.id');

    const aggregates = itemTypes
      .map((itemType) => {
        return {
          id: itemType.id,
          title: itemType.title,
          traitTitle: itemType.trait.title,
          path: itemType.path,
          unit: itemType.trait.quantityUnit,
          in: sum((purchased[itemType.id] || []).map((v) => v.quantity)),
          out: sum((out[itemType.id] || []).filter((v) => !v.isOut).map((v) => v.quantity)),
          reIn: sum((out[itemType.id] || []).filter((v) => v.isOut).map((v) => v.quantity)),
        };
      })
      .map((itemType) => ({
        ...itemType,
        available: itemType.in - (itemType.out - itemType.reIn)
      } as InventoryAggregate));

    return aggregates;
  }
}
